import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { cleanRoom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-query';


export const useAddQuestionBulk = () => {
  const { ID: orgId } = useSelector(activeOrgSelector);
  const dispatch = useDispatch();

  return useMutation(
    async (
      { crId, questionIDs },
    ) => axiosInstance.post(cleanRoom(orgId).addQuestionBulk(crId), {
      questionIDs,
    }),
    {
      onSuccess: () => {
        dispatch(showAlert({
          message: 'Successfully added question(s) to the clean room',
          type: 'success',
        }));
      },
      onError: (err) => {
        dispatch(showAlert({
          message: err.response.data.message,
          type: 'error',
        }));
      },
    },
  );
};
